import styled from 'styled-components';

export const ObsHighLowContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    height: 48%;
    width: 100%;
    font-size: 16px;
    font-weight: 400;
    color: #ffffff;
`;
